import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

const slider = (sliders, options) => {
  sliders.forEach(slider => {
    new Swiper(slider, options);
  })
}
export default slider;
